/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var padCountdownNumber = function(value) {
    return String(value).padStart(2, '0');
  };

  var updateProductCountdown = function(timer) {
    var endTime = new Date(timer.dataset.productCountdownEnd).getTime();

    if (!endTime) {
      timer.remove();
      return;
    }

    var remaining = endTime - Date.now();

    if (remaining <= 0) {
      timer.remove();
      return;
    }

    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor((remaining % 86400000) / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);

    var daysEl = timer.querySelector('[data-product-countdown-days]');
    var hoursEl = timer.querySelector('[data-product-countdown-hours]');
    var minutesEl = timer.querySelector('[data-product-countdown-minutes]');
    var secondsEl = timer.querySelector('[data-product-countdown-seconds]');

    if (daysEl) daysEl.textContent = padCountdownNumber(days);
    if (hoursEl) hoursEl.textContent = padCountdownNumber(hours);
    if (minutesEl) minutesEl.textContent = padCountdownNumber(minutes);
    if (secondsEl) secondsEl.textContent = padCountdownNumber(seconds);
  };

  var scanProductCountdowns = function(container) {
    (container || document).querySelectorAll('[data-product-countdown]').forEach(function(timer) {
      updateProductCountdown(timer);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scanProductCountdowns(document);
    });
  } else {
    scanProductCountdowns(document);
  }

  window.setInterval(function() {
    scanProductCountdowns(document);
  }, 1000);

  document.addEventListener('shopify:section:load', function(event) {
    scanProductCountdowns(event.target);
  });




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* ============================================================
   PRODUCT CARD VIDEO
   Shared cards appear in collections, search, featured collections,
   related products, complete-the-look, and homepage product sections.
   Play only cards near the viewport to protect initial page speed.
   ============================================================ */
(function () {
  function prepareCardVideo(container) {
    if (container.dataset.productCardVideoReady) return;
    container.dataset.productCardVideoReady = '1';
    var video = container.querySelector('video');
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var tryPlay = function () {
      if (document.hidden || !container.getClientRects().length) return;
      video.preload = 'auto';
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    };

    video.addEventListener('loadedmetadata', tryPlay);
    video.addEventListener('loadeddata', tryPlay);
    video.addEventListener('canplay', tryPlay);
    window.addEventListener('pageshow', tryPlay);

    if (!('IntersectionObserver' in window)) {
      tryPlay();
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          tryPlay();
          window.setTimeout(tryPlay, 300);
          window.setTimeout(tryPlay, 1200);
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '250px 0px', threshold: 0.15 });
    observer.observe(container);
  }

  function scanProductCardVideos(root) {
    (root || document).querySelectorAll('[data-product-card-video]').forEach(prepareCardVideo);
  }

  document.addEventListener('lazyloaded', function (event) {
    var gifCard = event.target.closest && event.target.closest('[data-product-card-gif]');
    if (gifCard) gifCard.classList.add('product-card-gif-loaded');
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scanProductCardVideos(document); });
  } else {
    scanProductCardVideos(document);
  }
  document.addEventListener('shopify:section:load', function (event) { scanProductCardVideos(event.target); });
})();

/* ============================================================
   PDP ANIMATED MEDIA
   - Reveal GIFs cleanly after the full asset decodes.
   - Load deferred videos shortly before they enter the viewport.
   - Explicitly apply Safari's muted/inline requirements and retry play.
   ============================================================ */
(function () {
  function prepareGif(gifSlide) {
    if (gifSlide.dataset.pdpGifReady) return;
    gifSlide.dataset.pdpGifReady = '1';
    var image = gifSlide.querySelector('[data-product-image]');
    if (!image) return;
    var reveal = function () { gifSlide.classList.add('pdp-gif-loaded'); };
    if (image.complete && image.naturalWidth > 0) reveal();
    else image.addEventListener('load', reveal, { once: true });
  }

  function configureVideo(video, slide) {
    if (!video || video.dataset.pdpAutoplayReady) return;
    video.dataset.pdpAutoplayReady = '1';
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('loop', '');

    var attemptPlay = function () {
      if (document.hidden || !slide.getClientRects().length) return;
      var slider = slide.closest('[data-product-single-media-slider]');
      var isCarousel = slider && slider.classList.contains('flickity-enabled');
      if (
        document.hidden ||
        !slide.getClientRects().length ||
        (isCarousel && slide.classList.contains('media--hidden')) ||
        (isCarousel && !slide.classList.contains('is-selected'))
      ) return;
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    };
    video.addEventListener('canplay', attemptPlay);
    video.addEventListener('loadeddata', attemptPlay);
    slide.addEventListener('theme:media:visible', attemptPlay);
    slide.addEventListener('theme:media:hidden', function () { video.pause(); });
    attemptPlay();
  }

  function loadVideo(slide) {
    if (slide.dataset.pdpVideoRequested) return;
    slide.dataset.pdpVideoRequested = '1';
    var slider = slide.closest('[data-product-single-media-slider]');
    if (
      window.matchMedia('(min-width: 768px)').matches &&
      slider &&
      !slider.classList.contains('flickity-enabled')
    ) {
      slide.classList.remove('media--hidden');
    }
    var button = slide.querySelector('[data-deferred-media-button]');
    if (button) button.click();

    var video = slide.querySelector('video');
    if (video) configureVideo(video, slide);
    else {
      var observer = new MutationObserver(function () {
        var insertedVideo = slide.querySelector('video');
        if (!insertedVideo) return;
        observer.disconnect();
        configureVideo(insertedVideo, slide);
      });
      observer.observe(slide, { childList: true, subtree: true });
    }
  }

  function initAnimatedMedia(root) {
    (root || document).querySelectorAll('.template-product [data-pdp-gif]').forEach(prepareGif);
    var slides = (root || document).querySelectorAll('.template-product [data-product-single-media-wrapper][data-video]');
    if (!slides.length) return;

    if ('IntersectionObserver' in window) {
      var viewportObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          viewportObserver.unobserve(entry.target);
          loadVideo(entry.target);
        });
      }, { rootMargin: '500px 0px', threshold: 0.01 });
      slides.forEach(function (slide) { viewportObserver.observe(slide); });
    } else {
      loadVideo(slides[0]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAnimatedMedia(document); });
  } else {
    initAnimatedMedia(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAnimatedMedia(event.target); });

  /* The base theme disables Flickity dragging whenever video playback starts.
     PDP videos autoplay, so that behavior would permanently lock mobile swipe. */
  document.addEventListener('theme:media:play', function (event) {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var slider = event.target.closest('.template-product [data-product-single-media-slider]');
    if (!slider) return;

    /* Stop the base Product handler on the slide from setting draggable=false. */
    event.stopPropagation();

    var restoreDragging = function () {
      if (!window.themeVendor || !window.themeVendor.Flickity) return;
      var flickity = window.themeVendor.Flickity.data(slider);
      if (!flickity) return;
      flickity.options.draggable = true;
      flickity.updateDraggable();
      slider.classList.remove('has-media-active');
      slider.classList.remove('is-pointer-down');
    };

    restoreDragging();
    window.requestAnimationFrame(restoreDragging);
  }, true);
})();

/* ============================================================
   QUICKBUY SLIDER
   Builds a working horizontal carousel inside the Quick View
   popup. The popup HTML is injected via the Section Rendering
   API, so we use a MutationObserver to wire up the controls
   each time a new gallery shows up.
   ============================================================ */
(function () {
  var SLIDER_SELECTOR = '.popup-quick-view .product-single__media-slider';
  var INIT_FLAG = 'qbSliderReady';

  function initSlider(slider) {
    if (slider.dataset[INIT_FLAG]) return;
    var gallery = slider.closest('.popup-quick-view__gallery');
    if (!gallery) return;
    var slides = slider.querySelectorAll('.product-single__media-slide');
    if (!slides.length) return;
    slider.dataset[INIT_FLAG] = '1';
    if (slides.length < 2) {
      gallery.setAttribute('data-qb-single', '');
      return;
    }
    if (gallery.querySelector('.qb-slider-arrow')) return;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'qb-slider-arrow qb-slider-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 2 L4 6 L8 10"/></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'qb-slider-arrow qb-slider-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 2 L8 6 L4 10"/></svg>';

    var dots = document.createElement('div');
    dots.className = 'qb-slider-dots';
    for (var i = 0; i < slides.length; i++) {
      var d = document.createElement('span');
      d.className = 'qb-slider-dots__dot' + (i === 0 ? ' qb-slider-dots__dot--active' : '');
      dots.appendChild(d);
    }

    gallery.appendChild(prev);
    gallery.appendChild(next);
    gallery.appendChild(dots);

    function currentIdx() {
      var w = slider.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / w)));
    }
    function update() {
      var idx = currentIdx();
      var children = dots.children;
      for (var i = 0; i < children.length; i++) {
        children[i].classList.toggle('qb-slider-dots__dot--active', i === idx);
      }
      prev.disabled = idx <= 0;
      next.disabled = idx >= slides.length - 1;
    }
    function go(delta) {
      var idx = currentIdx() + delta;
      if (idx < 0) idx = 0;
      if (idx > slides.length - 1) idx = slides.length - 1;
      slider.scrollTo({ left: idx * (slider.clientWidth || 1), behavior: 'smooth' });
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
    slider.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
    update();
  }

  function scan() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scan();
        return;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

/* ============================================================
   QUICKBUY: sync size pill highlight on first click
   The theme's popout JS at theme.js:4989-5000 only moves the FIRST
   "--current" class it finds when a size is clicked. The list items
   carry both .select-popout__item--current and .qb-popout__item--current,
   and only the former gets moved — leaving qb-popout__item--current on
   the previously selected item until the second click. This handler
   runs after the theme's listener (bubble phase) and rewrites
   .qb-popout__item--current to follow .select-popout__item--current,
   so the brown highlight tracks the actual variant on the first click.
   ============================================================ */
(function () {
  var ITEM_SELECTOR = '.qb-popout__item';
  var SELECT_CURRENT = 'select-popout__item--current';
  var QB_CURRENT = 'qb-popout__item--current';

  document.addEventListener('click', function (e) {
    var option = e.target.closest(
      '.popup-quick-view .selector-wrapper--qb-popout [data-popout-option]'
    );
    if (!option) return;

    var list = option.closest('.qb-popout__scroll, .select-popout__list__scroll');
    if (!list) return;

    list.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
      item.classList.toggle(QB_CURRENT, item.classList.contains(SELECT_CURRENT));
    });
  });
})();

/* ============================================================
   QUICKBUY: move title / price / size selector into the foot
   Color swatches stay in __body so the theme's swatch-init JS
   keeps working — only the title, price, and the custom size
   popout (which we built ourselves) are reparented.
   ============================================================ */
(function () {
  var ITEM_SELECTOR = '.popup-quick-view [data-quick-view-item]';
  var DONE_FLAG = 'qbReorganized';

  function reorganize(item) {
    if (item.dataset[DONE_FLAG]) return;
    var footInner = item.querySelector('.popup-quick-view__foot__inner');
    var submitHolder = item.querySelector('.product__submit__holder');
    if (!footInner || !submitHolder) return;

    var title = item.querySelector('.popup-quick-view__title');
    var priceBlock = item.querySelector('.popup-quick-view__body .product__block.product__price-and-badge');
    // The .selector-wrapper--qb-popout is the custom size popout we
    // build for the quickview only. It's safe to move because we own
    // the markup — no theme JS references its DOM position.
    var sizeWrapper = item.querySelector('.popup-quick-view__body .selector-wrapper--qb-popout');

    if (title && title.parentElement !== footInner) {
      footInner.insertBefore(title, submitHolder);
    }
    if (priceBlock && priceBlock.parentElement !== footInner) {
      footInner.insertBefore(priceBlock, submitHolder);
    }
    if (sizeWrapper && sizeWrapper.parentElement !== footInner) {
      footInner.insertBefore(sizeWrapper, submitHolder);
    }

    item.dataset[DONE_FLAG] = '1';
  }

  function scan() {
    document.querySelectorAll(ITEM_SELECTOR).forEach(reorganize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var qbObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scan();
        return;
      }
    }
  });
  qbObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

document.addEventListener('DOMContentLoaded', function() {
  var radios = document.querySelectorAll('.swatch__input');
  radios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      var colorval = document.querySelector('.swatch__input:checked').value;
      showColorImages(colorval);
      document.getElementById('swatchname').innerHTML = colorval;
    });
  });

  if (document.querySelectorAll('.swatch__input').length > 0) {
    var colorval = document.querySelector('.swatch__input:checked').value;
    showColorImages(colorval);
    document.getElementById('swatchname').innerHTML = colorval;
  }
  
});

window.onload = function() {
  if (document.querySelectorAll('.swatch__input:checked').length > 0) {
    var colorval = document.querySelector('.swatch__input:checked').value;
    showColorImages(colorval);
    
  }

// Set "In stock" as the default option in the availability filter
  if (document.querySelectorAll(".collection__filters-list .filter__input#filter-Availability-1").length > 0) {
    
     document.querySelectorAll(".collection__filters-list .filter__input#filter-Availability-1").forEach(function(felement) {
        felement.checked = true;
     });
  }

};

function showColorImages(colorname) {
  var imageallElements = document.querySelectorAll('.imageall');
  imageallElements.forEach(function(element) {
    element.classList.add('hideimage');
    element.classList.remove('is-visible');
    if (element.getAttribute('data-color') === colorname) {
      element.classList.remove('hideimage');
      element.classList.add('is-visible');
    }
  });

  if (window.innerWidth < 1008) {
    /*document.body.addEventListener('touchmove', function(e) {
      setTimeout(function() {
        console.log(2)
        var visibleImage = document.querySelector('.imageall.product-single__media-slide.is-selected.hideimage');
        if (visibleImage) {
          
          console.log(3)
          console.log(document.querySelector('.product-single__thumbnail.imageall.is-visible:first-child').getAttribute('data-id'));
          var divElement = document.querySelector('.imageall.product-single__thumbnail.is-visible:first-child');
          var event = new MouseEvent('click', {
            bubbles: 0
          });
          divElement.dispatchEvent(event);
        }
      }, 100);
    });*/
  }
}


function opennewsletter(){
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'Xwz57X']);
}

(function () {
  function delayButtonVisibility() {
    var buttons = document.querySelectorAll('.template-product button.product__popup__link');
    
    // Show all buttons after 1 second with inline styling
    setTimeout(function() {
      buttons.forEach(function(button) {
        button.style.display = 'inline-block';
      });
    }, 2000);
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', delayButtonVisibility);
  } else {
    delayButtonVisibility();
  }
})();